// Supported tools to be used in Copilot V2 actions
// "Default Tools"
export const CONTENT_REWRITE = 'content_rewrite';
export const TEXT_GENERATION = 'text_generate';
export const THINK = 'think';
export const WEB_SEARCH = 'web_search';

// "Copilot Tools"
export const COMPANY_NEWS = 'company_news';
export const COMPANY_TECH_STACK = 'company_tech_stack';
export const INVOICES_CREATE = 'invoices_create';
export const MARKETPLACE = 'marketplace';
export const PRICING_PACKAGING = 'pricing_packaging';
export const QUOTE_INFORMATION = 'quote_information';
export const QUOTE_PROPERTY_WRITE = 'quote_property_write';
export const QUOTE_REVIEW = 'quote_review';
export const WORKFLOW_CREATE = 'workflow_create';
export const WORKFLOW_GENERATION = 'workflow_generation';

// "CRM CHIRP Tools"
// https://private.hubteam.com/shoebill/service/com.hubspot.copilot.tools.rpc.CopilotCrmTools
export const CRM_CARD_GENERATE = 'crm_card_generate';
export const CRM_META_SEARCH = 'crm_meta_search';
export const CRM_OBJECT_LIST = 'crm_object_list';
export const CRM_OBJECT_SEARCH = 'crm_object_search';
export const CRM_OBJECT_SUMMARY = 'crm_object_summary';
export const CRM_OBJECT_UPSERT = 'crm_object_upsert';
export const CRM_OWNER_SEARCH = 'crm_owner_search';

// "Dashworks CHIRP Tools"
// https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksTools
export const DASHWORKS_SEARCH = 'dashworks_search';

// "Data Model CHIRP Tools"
// https://private.hubteam.com/shoebill/service/com.hubspot.blueprint.data.model.tools.rpc.DataModelTools
export const DATA_MODEL_GET_BEST_PRACTICES_AND_RULES = 'DataModelTools_getDataModelBestPracticesAndRules';
export const DATA_MODEL_GET_PORTAL_CONTEXT = 'DataModelTools_getPortalContext';
export const DATA_MODEL_FORMAT_DATA_MODEL_CONTENT = 'DataModelTools_formatDataModelContent';
export const DATA_MODEL_CREATE_CUSTOM_PROPERTIES = 'DataModelTools_createCustomProperties';
export const DATA_MODEL_CREATE_CUSTOM_PIPELINES = 'DataModelTools_createCustomPipelines';
export const DATA_MODEL_CREATE_ASSOCIATION_LABELS = 'DataModelTools_createAssociationLabels';
export const DATA_MODEL_CREATE_CUSTOM_OBJECT_TYPES = 'DataModelTools_createCustomObjectTypes';

// "Meeting CHIRP Tools"
// https://private.hubteam.com/shoebill/service/com.hubspot.breeze.assistant.experience.rpc.MeetingTools
export const LIST_MEETINGS = 'MeetingTools_listMeetings';
export const GET_MEETING = 'MeetingTools_getMeeting';
export const GET_MEETING_PREPARATION_DETAILS = 'MeetingTools_getMeetingPreparationDetails';
export const GET_MEETING_PREVIOUS_CALL_TRANSCRIPTS = 'MeetingTools_getMeetingPreviousCallTranscripts';

// TODO: Add mapping and update convertV1ActionToV2ToolInput to handle these Documentation Tools
// "Documentation Tools"
// https://private.hubteam.com/shoebill/service/com.hubspot.flywheel.support.bot.copilot.rpc.DocumentationTools
export const ASK_HUBSPOT = 'ask_hubspot';
export const HUBSPOT_HOW_TO = 'hubspot_how_to';

// TODO: Add mapping and update convertV1ActionToV2ToolInput to handle these Reporting Tools
// "Reporting CHIRP Tools"
// https://private.hubteam.com/shoebill/service/com.hubspot.reporting.generation.rpc.ReportingGenerationTools
export const REPORT_BUILDER = 'report_builder';
export const REPORTING_INSIGHTS_COPILOT_GENERATION = 'reporting_insights_copilot_generation';

// Map of CHIRP tool names to their fully qualified names
// This is part of our conversion of V1 actions to V2 tool inputs with Loadable Tools support
export const CHIRP_TOOL_MAP = {
  [CRM_CARD_GENERATE]: {
    chirpToolServiceFqcn: 'com.hubspot.copilot.tools.rpc.CopilotCrmTools',
    name: 'CopilotCrmTools_crmCardGenerate'
  },
  [CRM_META_SEARCH]: {
    chirpToolServiceFqcn: 'com.hubspot.copilot.tools.rpc.CopilotCrmTools',
    name: 'CopilotCrmTools_crmMetaSearch'
  },
  [CRM_OBJECT_LIST]: {
    chirpToolServiceFqcn: 'com.hubspot.copilot.tools.rpc.CopilotCrmTools',
    name: 'CopilotCrmTools_crmObjectList'
  },
  [CRM_OBJECT_SEARCH]: {
    chirpToolServiceFqcn: 'com.hubspot.copilot.tools.rpc.CopilotCrmTools',
    name: 'CopilotCrmTools_crmObjectSearch'
  },
  [CRM_OBJECT_SUMMARY]: {
    chirpToolServiceFqcn: 'com.hubspot.copilot.tools.rpc.CopilotCrmTools',
    name: 'CopilotCrmTools_crmObjectSummary'
  },
  [CRM_OBJECT_UPSERT]: {
    chirpToolServiceFqcn: 'com.hubspot.copilot.tools.rpc.CopilotCrmTools',
    name: 'CopilotCrmTools_crmObjectUpsert'
  },
  [CRM_OWNER_SEARCH]: {
    chirpToolServiceFqcn: 'com.hubspot.copilot.tools.rpc.CopilotCrmTools',
    name: 'CopilotCrmTools_crmOwnerSearch'
  },
  [DASHWORKS_SEARCH]: {
    chirpToolServiceFqcn: 'com.hubspot.dashworks.rpc.DashworksTools',
    name: 'DashworksTools_dashworksSearch'
  }
};

// Interactive Mode Tools
export const INTERACTIVE_TOOL = 'interactive_tool';
export const INTERACTIVE_TOOL_BUTTON_CLICK = 'interactive_tool_button_click';

// "Workflow CHIRP Tools"
export const BUILD_WORKFLOW_ACTIONS = 'WorkflowTools_buildActions';
export const BUILD_WORKFLOW_TRIGGERS = 'WorkflowTools_buildTriggers';
export const VALIDATE_WORKFLOW = 'WorkflowTools_validateWorkflow';
export const CREATE_WORKFLOW = 'WorkflowTools_createWorkflow';
export const FETCH_AVAILABLE_WORKFLOW_TRIGGERS = 'WorkflowTools_fetchAvailableWorkflowTriggers';
export const FETCH_AVAILABLE_WORKFLOW_ACTIONS = 'WorkflowTools_fetchAvailableWorkflowActionDefinitions';
export const FETCH_WORKFLOW_RESOURCES = 'WorkflowTools_fetchWorkflowResourcesPage';

// The following tools are not passed from the FE, but rather are used to map
// copilot_tool_call_start to a status message during streaming
export const CHANGE_FOCUS = 'load_tools';
export const CRM_BASIC_SEARCH = 'crm_basic_search';
export const CRM_OBJECT_SEARCH_V2 = 'crm_object_search_v2';

/**
 * @deprecated Replaced by CopilotCrmTools_crmObjectSummary
 */
export const FEEDBACK_SUBMISSION_SUMMARY = 'feedback_submission_summary';

/**
 * @deprecated Replaced by CopilotCrmTools_crmObjectSummary
 */
export const OBJECT_SUMMARY = 'object_summary';